import { ServiceFetch } from '../service-fetch'

export default class StockChangeInListModel extends ServiceFetch {
    getStockChangeInListBy = (data) => this.authFetch({
        url: 'stock-change-in-list/getStockChangeInListBy',
        method: 'POST',
        body: JSON.stringify(data),
    })
}